module.exports = __webpack_public_path__ + "img/lg.870b688c.png";